import styled from "styled-components";

export const StyledDiv = styled.div`
  display: grid;
  grid-template-rows: repeat(${(p) => p.$rows}, 1fr);
  grid-template-columns: repeat(${(p) => p.$cols}, 1fr);
  grid-gap: 0;
  padding: 0;
`;
